import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5023ecdf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-12 sm:gap-x4 md:gap-x8" }
const _hoisted_2 = { class: "col-span-12 sm:col-span-6" }
const _hoisted_3 = { class: "col-span-12 sm:col-span-6" }
const _hoisted_4 = { class: "mt-x3 sm:mt-0 mb-x1 md:mb-x3" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "w-full grid grid-cols-1 md:grid-cols-2 gap-x3" }
const _hoisted_8 = {
  key: 0,
  class: "cover-row"
}
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = {
  key: 1,
  class: "cover-row"
}
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = {
  key: 2,
  class: "cover-row"
}
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = {
  key: 3,
  class: "cover-row"
}
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = {
  key: 4,
  class: "cover-row"
}
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = {
  key: 5,
  class: "cover-row"
}
const _hoisted_19 = { class: "font-bold" }
const _hoisted_20 = {
  key: 6,
  class: "cover-row"
}
const _hoisted_21 = { class: "font-bold" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 7,
  class: "cover-row"
}
const _hoisted_24 = { class: "font-bold" }
const _hoisted_25 = { class: "cover-row" }
const _hoisted_26 = { class: "font-bold" }
const _hoisted_27 = {
  key: 8,
  class: "cover-row"
}
const _hoisted_28 = { class: "font-bold" }

import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { computed } from 'vue';
import TruncateText from '@/shared/navigation/TruncateText.vue';
import useProductSpecificationsData from '@/shared/product/details/ui/product-specifications/useProductSpecificationsData';
import PdfLinkDownload from '@/shared/navigation/pdf-link/PdfLinkDownload.vue';
import CertificatesList from '@/shared/product/details/ui/product-specifications/CertificatesList.vue';
import TestsList from '@/shared/product/details/ui/product-specifications/TestsList.vue';
import CO2EmissionsLogo from '@/shared/product/details/emissions/CO2EmissionsLogo.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCoverDetails',
  setup(__props) {

const { coverMaterial } = useProductSpecificationsData();

const showMaterialType = computed(() => coverMaterial.value?.materialType && labels.coverMaterialType);
const showMartindale = computed(() => coverMaterial.value?.martinDale && labels.martindale);
const showLightFastness = computed(() => coverMaterial.value?.lightFastness && labels.lightFastness);
const showPilling = computed(() => coverMaterial.value?.pilling && labels.coverPilling);
const showCountryOfOrigin = computed(() => coverMaterial.value?.countryOfOrigin && labels.countryOfOrigin);
const showWashingInstructions = computed(() => coverMaterial.value?.washingInstructions && labels.washingInstructions); // TODO: Add data and label for washing instructions
const showClimateEmissions = computed(() => coverMaterial.value?.fabricClimateEmission && labels.climateFootprintTitle);
const showCoverComposition = computed(() => coverMaterial.value?.compositions && labels.coverComposition);

const labels = useBlockLabels();

return (_ctx: any,_cache: any) => {
  const _component_ResponsiveImage = _resolveComponent("ResponsiveImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ResponsiveImage, {
        "is-product-image": true,
        "image-url": `/materials/${_unref(coverMaterial)?.imageName}.webp`,
        "aspect-ratio": { 'max-sm': 16/9, 'default': 1/1},
        "width-on-screen": {'xs': 100, 'sm': 50}
      }, null, 8, ["image-url"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(coverMaterial)?.name), 1),
      _createVNode(TruncateText, {
        "read-more-label": _unref(labels).coverReadMore,
        "read-less-label": _unref(labels).coverReadLess
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", {
            innerHTML: _unref(coverMaterial)?.description
          }, null, 8, _hoisted_5),
          _createElementVNode("p", {
            innerHTML: _unref(coverMaterial)?.recommendation
          }, null, 8, _hoisted_6)
        ]),
        _: 1
      }, 8, ["read-more-label", "read-less-label"]),
      _createElementVNode("dl", _hoisted_7, [
        (_unref(showMaterialType))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("dt", _hoisted_9, _toDisplayString(_unref(labels).coverMaterialType), 1),
              _createElementVNode("dd", null, _toDisplayString(_unref(coverMaterial)?.materialType), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(showMartindale))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("dt", _hoisted_11, _toDisplayString(_unref(labels).martindale), 1),
              _createElementVNode("dd", null, _toDisplayString(_unref(coverMaterial)?.martinDale), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(showLightFastness))
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("dt", _hoisted_13, _toDisplayString(_unref(labels).lightFastness), 1),
              _createElementVNode("dd", null, _toDisplayString(_unref(coverMaterial)?.lightFastness), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(showPilling))
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("dt", _hoisted_15, _toDisplayString(_unref(labels).coverPilling), 1),
              _createElementVNode("dd", null, _toDisplayString(_unref(coverMaterial)?.pilling), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(showCountryOfOrigin))
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("dt", _hoisted_17, _toDisplayString(_unref(labels).countryOfOrigin), 1),
              _createElementVNode("dd", null, _toDisplayString(_unref(coverMaterial)?.countryOfOrigin), 1)
            ]))
          : _createCommentVNode("", true),
        (_unref(showWashingInstructions))
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("dt", _hoisted_19, _toDisplayString(_unref(labels).washingInstructions), 1),
              _createElementVNode("dd", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(coverMaterial)?.washingInstructions, (item) => {
                  return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(item), 1))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(showCoverComposition))
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("dt", _hoisted_21, _toDisplayString(_unref(labels).coverComposition), 1),
              _createElementVNode("dd", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(coverMaterial)?.compositions, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: item.material
                  }, [
                    _createTextVNode(_toDisplayString(item.percentage) + "% " + _toDisplayString(item.material) + " ", 1),
                    (index !== _unref(coverMaterial)?.compositions.length - 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, " / "))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(showClimateEmissions))
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("dt", _hoisted_24, [
                _createVNode(CO2EmissionsLogo, { class: "h-16 mr-x1" }),
                _createTextVNode(_toDisplayString(_unref(labels).climateFootprintTitle), 1)
              ]),
              _createElementVNode("dd", null, [
                _createTextVNode(_toDisplayString(_unref(coverMaterial)?.fabricClimateEmission?.climateEmission.emissionValue) + " " + _toDisplayString(_unref(coverMaterial)?.fabricClimateEmission?.climateEmission.screeningSpecification) + " ", 1),
                (_unref(coverMaterial)?.fabricClimateEmission?.documentationUrl)
                  ? (_openBlock(), _createBlock(PdfLinkDownload, {
                      key: 0,
                      class: "mt-x2 text-left",
                      label: _unref(labels).transparencyDocumentationDownload,
                      "is-direct-link": true,
                      url: _unref(coverMaterial)?.fabricClimateEmission?.documentationUrl
                    }, null, 8, ["label", "url"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("dt", _hoisted_26, _toDisplayString(_unref(labels).testsTitle), 1),
          _createElementVNode("dd", null, [
            (_unref(coverMaterial)?.fabricTests?.length)
              ? (_openBlock(), _createBlock(TestsList, {
                  key: 0,
                  title: undefined,
                  tests: _unref(coverMaterial)?.fabricTests
                }, null, 8, ["tests"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_unref(coverMaterial)?.fabricCertificates?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("dt", _hoisted_28, _toDisplayString(_unref(labels).certificatesTitle), 1),
              _createElementVNode("dd", null, [
                _createVNode(CertificatesList, {
                  certificates: _unref(coverMaterial)?.fabricCertificates
                }, null, 8, ["certificates"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})